import { getBreakpoint, getBreakpointName, } from '@hn-ui/themes';
import { useWindowSize } from '@hn-front/utils';
export var useScreenName = function () {
    var width = useWindowSize().width;
    return getBreakpoint(width);
};
export var useBreakpointName = function () {
    var width = useWindowSize().width;
    return getBreakpointName(width);
};
